<form [formGroup]="guardianForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{title}}</h1>
    <p class="lead rocal" style="margin-bottom: 0px;">
      {{subtitle}}
    </p>

    <!-- Panel 1: Personal Info -->
    <ng-template #guardianInfo let-i="index">
      <div *ngIf="getGuardiansFormGroup(i)">
        <div class="line-section"></div>

        <div class="row half" *ngIf="i > 0">
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="Category" inputType="select"
            [ArrayItems]="GuardianOptions" label={{guardianTypeLabel}} hint={{guardianTypeHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>

        <div class="row-alt">
          <div class="row-mini">
            <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="Title" label={{titleLabel}}
              hint={{titleHint}} inputType="auto-complete" [loadingOptions]="loadingTitles" [ArrayItems]="TitleOptions"
              required="false" [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>

            <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="FirstName" label={{fNameLabel}}
              hint={{fNameHint}} [runSuggestions]="true" [suggestFunction]="suggestSettlors.bind(this)"
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

          </div>

          <div class="row-mini">
            <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="MiddleName" label={{mNameLabel}}
              hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="LastName" label={{surnameLabel}}
              hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

        </div>

        <div class="row">
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="Phone" class="grid-item" label={{phoneLabel}}
            inputType="phone" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="Email" class="grid-item" label={{emailLabel}}
            hint={{emailLabel}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>

        <div class="row">
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="IDNo" class="grid-item" label={{idLabel}}
            hint={{idHint}} [runSuggestions]="true" [suggestFunction]="suggestSettlors.bind(this)"
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="KraPin"
            [required]="region == 1 ? 'false' : 'true' "
            [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
            class="grid-item" label={{kraPinLabel}} hint={{kraPinHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

        </div>

        <div class="line" style="margin-bottom: 5px;"></div>
        <div class="flex">
          <p class="brue margin">
            {{'Beneficiaries'}}
          </p>
        </div>

        <p style="color: #646464; line-height: 1.5;">
          A Guardian <b>MUST</b> have beneficiaries assigned under them. The same beneficiary can also be assigned to
          multiple guardians
        </p>

        <div class="row">
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="GuardianBens" label={{bensLabel}}
            hint={{bensHint}} inputType="multi-select" [ArrayItems]="BeneficiaryList"
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>

      </div>
    </ng-template>

    <!-- Panel 2: Upload Documents -->
    <ng-template #uploadDocs let-i="index">
      <div *ngIf="getGuardiansFormGroup(i)">
        <div class="line-section"></div>

        <div class="row">
          <app-input [formGroup]="getGuardiansFormGroup(i)" controlName="IDNoImage"
            [fileFunction]="updateIDObject.bind(this, i)"
            [existingFileName]="guardians[i]?.IDNoImage?.name != '' ? guardians[i]?.IDNoImage?.name : '' "
            class="grid-item" label={{idFileLabel}} inputType="file" [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getGuardiansFormGroup(i)"
            [required]="region == 1 ? 'false' : 'true' "
            [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
            controlName="KraPinImage" [fileFunction]="updateKraObject.bind(this, i)"
            [existingFileName]="guardians[i]?.KraPinImage?.name != '' ? guardians[i]?.KraPinImage?.name : '' "
            class="grid-item" label={{kraFileLabel}} inputType="file" [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

      </div>
    </ng-template>


    <div formArrayName="guardians">
      <div *ngFor="let guardian of getGuardians().controls; let i=index" [formGroupName]="i"
        style="position: relative;">

        <div class="flex godolkin" style="margin-top: 0px; padding-bottom: 8px;">
          <p class="flex brue margin" style="font-weight: 600; font-size: 1.3em;" *ngIf="getGuardians().length > 1">
            {{'Guardian ' + (i+1)}}
          </p>

          <div class="flex suggestions" *ngIf="i === getGuardians().length-1 && suggestions !== null" [@bounceIn]
            #suggestBox>
            <div class="flex suggest">
              Autofill
            </div>

            <div class="flex sugg-holder">
              <div [@slideInRight] *ngFor="let suggestion of suggestions; let s=index"
                (click)="patchSuggestedValues(i, suggestion)" class="flex suggestion">
                {{ suggestion.FirstName +' ' +suggestion.LastName }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex" style="width: 100%; align-items: center; justify-content: center;">
          <div class="flex brief" *ngIf="i === getGuardians().length-1 && suggestions === null && showSuggestHint"
            [@bounceIn]>
            If the Guardian is an existing Settlor, use the ID or First Name fields to search and autofill their details
          </div>
        </div>


        <!-- Accordion -->
        <app-section [panels]="guardianPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>
        <!-- ++++++++++++++++++++++++++++ -->


        <!-- REMOVE BUTTON -->
        <div class="action-buttons">
          <button mat-stroked-button type="button" class="remove" (click)="removeGuardian(i)"
            *ngIf="getGuardians().length > 1">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{ loadingRemove ? 'Removing guardian' : removeGuardianText }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getGuardians() && !confirmFormMatchesRecord(i)"
            [disabled]="loading || loadingRemove" (click)="updateRecord(i)">
            <span class="button-text">
              {{ 'Update Guardian ' +(i+1) }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- BUTTTON Add Guardian -->
    <div class="blueStroke row"
      [ngClass]="{'min-55' : getGuardians().length > 1 || guardians[guardians.length-1].done}">
      <button mat-stroked-button *ngIf="guardians[guardians.length-1] && guardians[guardians.length-1].done"
        type="button" (click)="addNewGuardian()">
        <span class="button-text">
          {{ addButtonText }}
        </span>
      </button>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;"
    [text]="loading ? loadingText : guardians[guardians.length-1].done ? 'Next' : buttonText "
    [formValid]="guardianForm.valid || guardians[guardians.length-1].done === true"
    [showContinue]="guardianForm.valid ? 'true' : 'false'" [saveFunction]="updateProgress.bind(this)"
    [buttonClickHandler]="submitForm.bind(this)"></app-form-bottom>
</form>

<app-assign-guardian *ngIf="showAssignPopup" (closeModal)="toggleAssignPopup(false)" (closeAndProceed)="closeAssignPopup()"
  [beneficiaries]="BeneficiaryList" [guardians]="GuardianList">
</app-assign-guardian>